<template>
  <div class="app-body">
    <Sidebar/>
    <main class="main">
      <AppHeader/>
      <div class="container">
        <breadcrumb :list="list"/>
        <router-view v-if="loadingUser"></router-view>
      </div>
      <AppFooter/>
    </main>
  </div>
</template>

<script>
  import AppHeader from '../components/Header'
  import Sidebar from '../components/Sidebar'
  import AppFooter from '../components/Footer'
  import Breadcrumb from '../components/Breadcrumb'
  import {baseApi} from '../configs/urls'

  export default {
    name: 'full',
    components: {
      AppHeader,
      Sidebar,
      AppFooter,
      Breadcrumb
    },
    data () {
      return {
        auth: {},
        loadingPermissions: false,
        loadingUser: false
      }
    },
    computed: {
      name () {
        return this.$route.name
      },

      list () {
        return this.$route.matched
      }
    },
    methods: {

      syncAuth () {
        const loading = this.$loading({
          lock: true
        })

        this.loadingUser = false
        this.$http.get('user')
          .then(
            (response) => {
              this.$auth.setAuthenticatedUser(response.body)
              this.$store.state.auth = this.$auth.getAuthenticatedUser()
              this.loadingUser = true
              loading.close()
            },
            (res) => {
              console.log(res.statusText)
              this.loadingUser = false
              loading.close()
            }
          )
      },
      fetchPermissions () {
        if (this.$auth.hasPermissions()) {
          this.$store.state.permissions = this.$auth.getPermissions()
        }
        this.$http.post(baseApi + '/auth/permissions')
          .then(
            (response) => {
              this.$auth.savePermissions(response.body)
              this.$store.state.permissions = this.$auth.getPermissions()
            }
          )
      }
    },
    mounted () {
      this.syncAuth()
      this.fetchPermissions()
    }
  }
</script>



// WEBPACK FOOTER //
// src/containers/Full.vue